import axiosService from '../plugins/axiosService'

export default {
    async captureAll(){
        return axiosService.get('/api/capture/all')
    }
}
